// dataBookingsSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { bookingsApi } from "./bookingsApi";

/* -- initial state ------------------------------------------------------- */
const initialState = {
    status: "idle", // idle | loading | partiallyLoaded | loaded | error
    data: [],
    last_ResDate: null,
    hotelID: null,
    error: null,
};

/* -- slice --------------------------------------------------------------- */
const slice = createSlice({
    name: "dataBookings",
    initialState,
    reducers: {
        loading_Bookings: (state, action) => {
            const { hotelID } = action.payload;
            state.data = [];
            state.hotelID = hotelID;
            state.status = "loading";
        },
        partiallyLoad_Bookings: (state, action) => {
            // console.log("partially loading bookings manual reducer->>>>>>>>>", {
            //     state,
            //     action,
            // });

            const { data, hotelID, lastResDate } = action.payload;

            state.data = data;
            state.hotelID = hotelID;
            state.last_ResDate = lastResDate;
            state.status = "partiallyLoaded";
        },
        load_Bookings: (state, action) => {
            // console.log("load bookings manual reducer->>>>>>>>>", {
            //     state,
            //     action,
            // });
            const { data, hotelID, lastResDate } = action.payload;

            state.data = data;
            state.hotelID = hotelID;
            state.last_ResDate = lastResDate;
            state.status = "loaded";
        },
    },
    extraReducers: (builder) =>
        builder
            /* pending ---------------------------------------------------- */
            .addMatcher(
                bookingsApi.endpoints.getBookings.matchPending,
                (state, { meta }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                }
            )
            /* fulfilled --------------------------------------------------- */
            .addMatcher(
                bookingsApi.endpoints.getBookings.matchFulfilled,
                (state, { meta, payload }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                }
            )
            /* rejected ---------------------------------------------------- */
            .addMatcher(
                bookingsApi.endpoints.getBookings.matchRejected,
                (state, { error }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                    // state.status = "error";
                    // state.error = error;
                    console.log("Matcher Rejected", { state });
                }
            ),
});

export default slice.reducer;
export const { load_Bookings, partiallyLoad_Bookings, loading_Bookings } =
    slice.actions;
